import User from '@models/User'
import { getProfileEpoch } from '@utils/helpers'

export function buildAvatarUrl(user: User): string {
  let uri = `/users/avatars/${user.external_id}`
  // Cache-bust the URL if it's the current user, so they can see changes immediately
  const profileEpoch = getProfileEpoch()
  if (profileEpoch) {
    uri += `?${profileEpoch}`
  }
  return uri
}
